import { Component } from '@contorion/core';

export class PrivacyCenterComponent extends Component {

    constructor(protected element: HTMLElement) {
        super(element);
        this.element.addEventListener('click', this.onClick);
    }

    private onClick = () => {
        window.tC?.privacyCenter.showPrivacyCenter();
    }
}
